import { useTranslation } from 'react-i18next'
import KpiCards, { type KpiCard } from '../../../components/ui/KpiCards'
import type { ActivitySummary } from '../types'

interface ActivityKpisProps {
  summary?: ActivitySummary
  loading?: boolean
}

/**
 * Etkinlik Listesi KPI kartları (US4) — paylaşılan ui/KpiCards ile (Talep Listesi kalıbı; Reuse Mandate).
 * Kapsam-geneli değerler: Bekliyor / Katılıyor / Orta Öncelik / Ortalama Stratejik Skor. Ortalama skoru
 * olan etkinlik yoksa 0 gösterilir (kart değeri; boş hücre yer tutucusu kuralı tabloya özgüdür).
 */
export default function ActivityKpis({ summary, loading }: Readonly<ActivityKpisProps>) {
  const { t } = useTranslation()

  const cards: KpiCard[] = [
    { key: 'waiting', label: t('activity.list.kpi.waiting'), value: String(summary?.waiting ?? 0) },
    {
      key: 'attending',
      label: t('activity.list.kpi.attending'),
      value: String(summary?.attending ?? 0),
    },
    {
      key: 'mediumPriority',
      label: t('activity.list.kpi.mediumPriority'),
      value: String(summary?.mediumPriority ?? 0),
    },
    {
      key: 'avgScore',
      label: t('activity.list.kpi.avgScore'),
      value: String(summary?.avgStrategicScore ?? 0),
    },
  ]

  return <KpiCards cards={cards} loading={loading} />
}
